import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Alert, message } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LmHeader from '../components/LmHeader.jsx';
import LmFooter from '../components/LmFooter.jsx';

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token');
  const userType = searchParams.get('type') || 'client';
  const isClient = userType === 'client';

  const backTo = isClient ? '/enter' : '/login';

  useEffect(() => {
    if (!token) {
      setError('Недействительная ссылка для восстановления пароля');
    }
  }, [token]);

  const onFinish = async (values) => {
    if (!token) return;

    setError('');
    setLoading(true);

    try {
      const endpoint = isClient
        ? 'https://limitverify.ru:5000/api/clients/reset-password'
        : 'https://limitverify.ru:5000/api/auth/reset-password';

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: token,
          newPassword: values.password
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
        message.success('Пароль успешно изменен');
      } else {
        setError(data.error || 'Произошла ошибка');
      }
    } catch (err) {
      setError('Произошла ошибка при сбросе пароля');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lm-page">
      <LmHeader actions={[{ label: 'Вход', onClick: () => navigate(backTo) }]} />

      <main className="lm-content lm-content--center">
        <div className="lm-auth">
          {success ? (
            <>
              <div className="lm-auth__head">
                <h1 className="lm-auth__title">Пароль изменён</h1>
                <span className="lm-auth__sub">
                  Ваш пароль был успешно изменён. Теперь вы можете войти в систему с новым паролем.
                </span>
              </div>
              <button type="button" className="lm-btn lm-btn--block" onClick={() => navigate(backTo)}>
                Войти в систему
              </button>
            </>
          ) : !token ? (
            <>
              <div className="lm-auth__head">
                <h1 className="lm-auth__title">Ошибка</h1>
                <span className="lm-auth__sub lm-danger">
                  Недействительная ссылка для восстановления пароля
                </span>
              </div>
              <button type="button" className="lm-btn lm-btn--block" onClick={() => navigate(backTo)}>
                Вернуться к входу
              </button>
            </>
          ) : (
            <>
              <div className="lm-auth__head">
                <h1 className="lm-auth__title">Новый пароль</h1>
                <span className="lm-auth__sub">Введите новый пароль для вашего аккаунта</span>
              </div>

              {error && (
                <Alert message={error} type="error" closable onClose={() => setError('')} />
              )}

              <Form name="reset-password" onFinish={onFinish} layout="vertical" requiredMark={false} className="lm-auth__form">
                <Form.Item
                  name="password"
                  label="Новый пароль"
                  style={{ marginBottom: 0 }}
                  rules={[
                    { required: true, message: 'Введите новый пароль' },
                    { min: 6, message: 'Пароль должен содержать минимум 6 символов' }
                  ]}
                >
                  <Input.Password placeholder="Введите новый пароль" />
                </Form.Item>

                <Form.Item
                  name="confirmPassword"
                  label="Подтвердите пароль"
                  dependencies={['password']}
                  style={{ marginBottom: 0 }}
                  rules={[
                    { required: true, message: 'Подтвердите пароль' },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Пароли не совпадают'));
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder="Подтвердите новый пароль" />
                </Form.Item>

                <Form.Item style={{ marginBottom: 0 }}>
                  <Button htmlType="submit" loading={loading} block style={{ textTransform: 'uppercase' }}>
                    Изменить пароль
                  </Button>
                </Form.Item>
              </Form>
            </>
          )}
        </div>
      </main>

      <LmFooter />
    </div>
  );
};

export default ResetPassword;
